import { Switch, Form } from "antd";

const TabConnections = () => {
  const [form] = Form.useForm();

  return (
    <Form id="formConnection" form={form} style={{ padding: "24px 32px" }}>
      <Form.Item label="MorningStar ID / License /">
        <Switch disabled size="small" />
      </Form.Item>
      <Form.Item label="News.AI license, etc">
        <Switch disabled size="small" />
      </Form.Item>
      <Form.Item label="Other...">
        <Switch disabled size="small" />
      </Form.Item>
    </Form>
  );
};

export default TabConnections;
